"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var stimulus_1 = require("stimulus");
var google_analytics_manager_1 = __importDefault(require("@hikakaku/shared/util/google_analytics_manager"));
var TelephoneEstimateableStoreController = /** @class */ (function (_super) {
    __extends(TelephoneEstimateableStoreController, _super);
    function TelephoneEstimateableStoreController() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.sendEvent = function () {
            google_analytics_manager_1.default.postGAEvent((_this.data.get('eventName') || ''), (_this.data.get('eventAction') || ''), (_this.data.get('eventLabel') || ''));
        };
        return _this;
    }
    return TelephoneEstimateableStoreController;
}(stimulus_1.Controller));
exports.default = TelephoneEstimateableStoreController;
